"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Irrigator = void 0;
const tslib_1 = require("tslib");
const datamodel_core_1 = require("@iotv/datamodel-core");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const DefinitionAndHelpers_1 = require("../../DefinitionAndHelpers");
const ERROR_EXCLUDE_LIST = ['runawayError', 'linkCheckErr'];
const typeName = 'Irrigator';
const OFFLINETHRESHOLDMS = iotv_v3_types_1.Milliseconds.DAY;
const parseErrors = (errors) => {
    const foundErrors = [];
    if (errors) {
        // const data = JSON.parse(errors);
        const data = errors;
        for (let key in data) {
            let val = data[key];
            if (val === 1 && !!!ERROR_EXCLUDE_LIST.includes(key)) {
                foundErrors.push(key);
            }
        }
    }
    if (foundErrors.length === 0) {
        return undefined;
    }
    else {
        return foundErrors;
    }
};
class Irrigator extends datamodel_core_1.DeviceEnabledType {
    constructor(ob) {
        var _a, _b, _c;
        // super(ob.type || typeName)
        super(ob.type || typeName, ob);
        this.getStatus = (irrigator = this, mapper = this.nodeEdgeMapper) => {
            const status = [];
            const now = new Date();
            const lastSeen = new Date(irrigator.updated_at);
            if (isNaN(lastSeen === null || lastSeen === void 0 ? void 0 : lastSeen.getTime())) {
                status.push(DefinitionAndHelpers_1.IrrStatusTypes.UNSEEN);
                // status.push(StatusTypes.OFFLINE);
            }
            if ((lastSeen === null || lastSeen === void 0 ? void 0 : lastSeen.getTime()) < now.getTime() - OFFLINETHRESHOLDMS) {
                status.push(DefinitionAndHelpers_1.IrrStatusTypes.OFFLINE);
            }
            if (irrigator.pause) {
                status.push(DefinitionAndHelpers_1.IrrStatusTypes.AREAPAUSED);
            }
            // if (irrigator.disabled) {
            //   status.push(IrrStatusTypes.DISABLED)
            // }
            if (parseErrors(irrigator.error)) {
                status.push(DefinitionAndHelpers_1.IrrStatusTypes.ERROR);
            }
            if (irrigator.operating) {
                status.push(DefinitionAndHelpers_1.IrrStatusTypes.IRRIGATING);
            }
            const parentPaddock = mapper && mapper.getAdjacentNodes(irrigator, { objectTypeId: 'Area' })[0];
            if ((parentPaddock === null || parentPaddock === void 0 ? void 0 : parentPaddock.pause) === true) {
                status.push(DefinitionAndHelpers_1.IrrStatusTypes.AREAPAUSED);
            }
            if (irrigator.incomingProgramme !== undefined && !(status.includes(DefinitionAndHelpers_1.IrrStatusTypes.DISABLED) || status.includes(DefinitionAndHelpers_1.IrrStatusTypes.AREAPAUSED))) {
                status.push(DefinitionAndHelpers_1.IrrStatusTypes.AWAITINGPROGRAMME);
            }
            if (status.length === 0) {
                status.push(DefinitionAndHelpers_1.IrrStatusTypes.ONLINE);
            }
            return status;
        };
        this.updateFromDeviceMessage = DefinitionAndHelpers_1.updateEntity.bind(this);
        this.calcStatus = ob ? this.getStatus(ob) : undefined;
        this.timestamp = (_a = ob.timestamp) !== null && _a !== void 0 ? _a : Date.now();
        this.ingestion = ob.ingestion;
        this.pause = (_b = ob.pause) !== null && _b !== void 0 ? _b : false;
        this.incomingEuis = ob.incomingEuis;
        this.solenoidVoltage = ob.solenoidVoltage;
        this.solenoidVoltageEUI = ob.solenoidVoltageEUI;
        this.desiredVoltage = ob.desiredVoltage;
        this.updated_at = ob.updated_at;
        this.incomingProgramme = ob.incomingProgramme;
        this.currentProgramme = ob.currentProgramme;
        this.retryCount = ob.retryCount;
        this.batteryPercentage = (_c = ob.batteryPercentage) !== null && _c !== void 0 ? _c : null;
        delete this.updatedAt;
    }
    reportedScheduleEqualsRequested() {
        let equal = undefined;
        const requested = this.lastRequestedConfig;
        const reported = this.config;
        if (requested && reported) {
            //both defined
            requested.forEach((requestedSchedule, i) => {
                const reportedScehdule = reported[i];
                if (reportedScehdule) {
                    const match = (0, datamodel_core_1.objectsMatch)(requestedSchedule, reportedScehdule); //
                    if (!match)
                        console.log(`reported and requested schedules dont match on item ${i}`, { requestedSchedule, reportedScehdule });
                    equal = !!((equal || equal === undefined) && match); // dont reset once false
                }
                else
                    equal = false;
            });
        }
        else if (reported || requested) {
            // one is defined but not the other
            equal = false;
        }
        else {
            // neither defined, so we will return undefined
        }
        return equal;
    }
    // battery implemented by inherited deviceBatteryVoltage
    get schedulesMatch() {
        return this.reportedScheduleEqualsRequested();
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of sprinkler',
                required: true,
            },
            sprinklerApplicationRate: {
                type: 'Number',
                editable: true,
                label: 'Sprinkler Rate (mm/hr)',
                name: 'Sprinkler Rate (mm/hr)',
                // required: true,
            },
            model: {
                type: 'Enum',
                enumKv: DefinitionAndHelpers_1.SprinklerType,
                editable: true,
                label: 'Sprinkler Model',
                name: 'Sprinkler Model',
            },
            sprinklerCoverage: {
                type: 'Enum',
                enumKv: DefinitionAndHelpers_1.SprinklerCoverage,
                editable: true,
                label: 'Sprinkler Coverage',
                name: 'Sprinkler Coverage',
            },
            // solenoidModel: {
            //   type: 'Enum',
            //   enumKv: getEnumShape(SolenoidOptions),
            //   editable: true,
            //   label: 'Solenoid Model',
            //   name: 'Solenoid Model',
            // },
            // irrigatorType: {
            //   type: 'Enum',
            //   enumKv: IrrigatorType,
            //   editable: true,
            //   label: 'Type',
            //   name: 'type',
            //   description: 'Sprinkler model type (Solid State, Pivot, Lateral, Traveling, K-Line, Gun)',
            // },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.Irrigator = Irrigator;
tslib_1.__decorate([
    (0, datamodel_core_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function)
], Irrigator.prototype, "updateFromDeviceMessage", void 0);
